import { isInstallerNativeApp } from './installerSms';

const getCapacitor = () => {
    if (typeof window === 'undefined') return null;
    return window.Capacitor || null;
};

export const getInstallerBarcodePlugin = () => {
    if (!isInstallerNativeApp()) return null;

    const Cap = getCapacitor();
    if (Cap?.Plugins?.InstallerBarcode) {
        return Cap.Plugins.InstallerBarcode;
    }
    if (typeof Cap?.registerPlugin === 'function') {
        return Cap.registerPlugin('InstallerBarcode');
    }
    return null;
};

export const canScanIssueQr = () =>
    Boolean(getInstallerBarcodePlugin());

export const scanIssueQrNative = async () => {
    const plugin = getInstallerBarcodePlugin();
    if (!plugin) {
        throw new Error(
            'Сканер QR доступен только в приложении монтажника'
        );
    }

    const result = await plugin.scan();
    if (result?.cancelled) {
        return { cancelled: true, value: '' };
    }

    return {
        cancelled: false,
        value: String(result?.value || '').trim()
    };
};

export const canScanQr = canScanIssueQr;

export const parseIssueCodeFromScan = raw => {
    const text = String(raw || '').trim();
    if (!text) return '';

    try {
        const obj = JSON.parse(text);
        if (obj && (obj.code || obj.type === 'tmc_issue')) {
            return String(obj.code || '').trim().toUpperCase();
        }
    } catch (_) {
        /* not JSON */
    }

    const tagged = text.match(/TMCISSUE[:\s-]*([A-Z0-9]{6,32})/i);
    if (tagged) return tagged[1].toUpperCase();

    if (/^[A-Z0-9]{6,32}$/i.test(text)) {
        return text.toUpperCase();
    }

    return '';
};
